import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    collapsed: false,
};

const sidebarReducer = createSlice({
    name: "sidebar",
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.collapsed = !state.collapsed;
        },
        setSidebar: (state, action) => {
            state.collapsed = action.payload;
        },
    },
});

export const { toggleSidebar, setSidebar } = sidebarReducer.actions;
export default sidebarReducer.reducer;
